// @ts-check

import { customerType } from '@/core/constants'
import cleanSource from '@/helpers/clean-source'
import { removeNulls } from '@/helpers/objectMutations'

function serializeInvoiceCustomer(customerObject) {
  const customer = cleanSource({ ...customerObject })

  // Remove person specific properties if customer is a company
  if (customer.type === customerType.COMPANY) {
    customer.first_name = null
    customer.last_name = null
  }

  // Remove company specific properties if customer is a private person
  if (customer.type === customerType.PERSON) {
    customer.business_id = null
    customer.company_name = null
    customer.contact_name = null
  }

  return customer
}

export function serializeInvoiceEntry(entryObject) {
  const entry = cleanSource({ ...entryObject })
  delete entry.id
  delete entry.due_date
  delete entry.invoice_date
  delete entry.description

  entry.customer = serializeInvoiceCustomer(entry.customer)

  entry.invoice = serializeInvoice({
    ...entry.invoice,
    shipping: entry.customer.shipping
  })

  if (entry.items?.every(({ title }) => !title)) {
    delete entry.items
  }

  removeNulls(entry)

  return entry
}

function serializeInvoice(invoiceObject) {
  return cleanSource({ ...invoiceObject })
}

export default {}
